module.exports = __webpack_public_path__ + "assets/img/al7.bd6f42aa.jpg";